import React, { FC, ReactNode, useState } from 'react';
import { Divider, SelectProps } from 'antd';
import Select, { SelectValue } from 'antd/lib/select';
import redioIcon from '../../../images/select/redio-checked.svg'

import { CustomSelect } from './style';
import { CustomInputSearch } from '../IPOInput/style';

type ISelectProps = SelectProps<SelectValue> & {
	showSearch?: boolean;
	children?: JSX.Element[];
	optionList?: {
		value: string;
		label: ReactNode;
	}[];
};

export const IPOSelect: FC<ISelectProps> = ({ value, showSearch, children, optionList, ...selectProps }) => {
	showSearch = showSearch ?? false;
	const [searchVal, setSearchVal] = useState<string>('');
	const [copySearch, setCopySearch] = useState<string>('');
	return (
		<CustomSelect
			value={value}
			searchValue={searchVal}
			showSearch={false}
			style={{ width: '100%' }}
			onDropdownVisibleChange={open => !open && setSearchVal('')} //关闭的时候，搜索有值会导致无法正常展开
			optionFilterProp="label"
			dropdownRender={dom => (
				<div>
					{showSearch && (
						<>
							<CustomInputSearch
								value={copySearch}
								onChange={e => setCopySearch(e.target.value)}
								onPressEnter={(e) => {
									e.stopPropagation();
									setSearchVal(copySearch);
								}}
								style={{ width: '97%', marginLeft: '1.5%' }}
							/>
							<Divider style={{ margin: '6px 0' }} />
						</>
					)}
					{dom}
				</div>
			)}
			{...selectProps}>
			{
				children
			}
			{
				optionList && optionList.map(item => {
					return (
						<Select.Option
							value={item.value}
							label={item.label}
							key={item.value}>
							<div className='select-label-wrap'>
								<>
									{item.label}
									{item.value === value && <img src={redioIcon} />}
								</>
							</div>
						</Select.Option>)
				})
			}
		</CustomSelect>
	);
};
